export default __webpack_public_path__ + "static/media/boo-setting.0088b63a.png";